export const FILE_TYPES = {
  previousYearTaxReturn: 'PreviousYearTaxReturn',
};
